import { initDatadogLogs } from '@calm-web/logger';

import { redactSensitiveUrl } from '@/utils/sensitivePaths';

export const initWwwDatadogLogs = (): void => {
	initDatadogLogs({
		service: 'web-www',
		version: process.env.BUILD_ID,
		env: process.env.NEXT_PUBLIC_LOG_ENV ?? 'local',
		// Datadog Logs is a separate product from RUM and does not share its beforeSend, so a
		// credential in the page URL would otherwise ride along on every client log.
		beforeSend: event => {
			event.view.url = redactSensitiveUrl(event.view.url);
			if (event.view.referrer) {
				event.view.referrer = redactSensitiveUrl(event.view.referrer);
			}
			return true;
		},
	});
};
